import { ABP, eLayoutType } from '@abp/ng.core';

export const BOOKING_REQUEST_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/booking-requests',
    iconClass: 'fas fa-file-alt',
    name: '::Menu:BookingRequests',
    layout: eLayoutType.application,
    requiredPolicy: 'Mandir.BookingRequests',
    breadcrumbText: '::BookingRequests',
  },
];
